import { ReturnIcon } from "@images/svgIcons/returnIcon"
import { BoxProgrammingHeaederActionsView } from "@modules/boxPlanning/components/boxProgrammingHeader/boxProgrammingHeaderActionsView"
import { BoxProgrammation } from "@modules/boxProgrammation/boxProgrammationTypes"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { useCalendar } from "@modules/calendar/hooks/useCalendar"
import { word } from "@modules/core/utils/i18n"
import { Path } from "@modules/navigation/routes"
import { useBoxNavigate } from "@modules/navigation/useBoxNavigate"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

export const BoxProgrammingHeaderRightView: React.FC<{ boxProgrammation: BoxProgrammation }> = ({
  boxProgrammation,
}) => {
  const theme = useTheme()
  const boxNavigate = useBoxNavigate()
  const { selectedDate } = useCalendar()
  const canManageSessions = useBoxStaffPermission(BoxStaffPermissions.MANAGE_PROGRAMMING)

  return (
    <div className="flex flex-column justify-content-between align-items-start" style={{ height: "200px" }}>
      <div className="flex flex-column rounded-33 bg-neutralColor-50 md:p-2 xl:px-4 xl:py-3 justify-content-between w-full gap-3">
        <HUText fontStyle="TM" className="ml-2">
          {word("box.programmation.activity.viewProgrammation")}
        </HUText>
        {/* PERMISSIONS - Head-coach & Coach & Financial permissions denied */}
        {canManageSessions && <BoxProgrammingHeaederActionsView boxProgrammation={boxProgrammation} />}
      </div>

      {/* Back to timetable button */}
      <HUButton
        type="Left_Icon"
        colorType="Quaternary"
        size="M"
        onClick={() =>
          boxNavigate(Path.Box.ProgrammationDetails(boxProgrammation.id), {
            state: { selectedDate: selectedDate?.toString() ?? "" },
          })
        }
        icon={{ icon: ReturnIcon, iconProps: { color: theme.textPrimary } }}
        text={word("box.backToTimetable")}
        className="w-full"
      />
    </div>
  )
}
